document.addEventListener("DOMContentLoaded", function () {
  /*jshint loopfunc: true */
  'use strict';

  // Homepage hero carousel

  if (document.querySelector('.logo-slider')) {

    // Initialize slider
    jQuery('.logo-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button type="button" data-role="none" class="arrow-prev slick-arrow" aria-label="Previous slide" role="button"><svg class="icon" viewBox="0 0 66.9999 40.0002"><use xlink:href="#ic-caret"></use></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="arrow-next slick-arrow" aria-label="Next slide" role="button"><svg class="icon" viewBox="0 0 66.9999 40.0002"><use xlink:href="#ic-caret"></use></svg></div>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
      ]
    });
  }

  if (document.querySelector('.logo-slider')) {

    // Initialize slider
    jQuery('.testimonial-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" data-role="none" class="arrow-prev slick-arrow" aria-label="Previous slide" role="button"><svg class="icon" viewBox="0 0 66.9999 40.0002"><use xlink:href="#ic-caret"></use></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="arrow-next slick-arrow" aria-label="Next slide" role="button"><svg class="icon" viewBox="0 0 66.9999 40.0002"><use xlink:href="#ic-caret"></use></svg></div>',
    });
  }
});
